import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_DEPARTMENT = "LOADING_DEPARTMENT";
export const ERROR_DEPARTMENT = "ERROR_DEPARTMENT";
export const GET_ALL_DEPARTMENTS = "GET_ALL_DEPARTMENTS";
export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";

export const getAllDepartments = ({
  name = "",
  page = 1
}) => async dispatch => {
  try {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: true
    });
    const result = await axios().get(`/departments?name=${name}&page=${page}`);
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    return dispatch({
      type: GET_ALL_DEPARTMENTS,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: GET_ALL_DEPARTMENTS,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: error
    });
  }
};

export const getDepartment = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: true
    });
    const result = await axios().get(`/departments/${id}`);
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: GET_DEPARTMENT,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: GET_DEPARTMENT,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: error
    });
  }
};

export const addDepartment = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: true
    });
    const result = await axios().post(`/departments`, data);
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: null
    });
    dispatch({
      type: ADD_DEPARTMENT,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: ADD_DEPARTMENT,
      payload: null
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: error
    });
  }
};

export const updateDepartment = ({ id, data }) => async dispatch => {
  try {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: true
    });
    const result = await axios().put(`/departments/${id}`, data);
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: null
    });
    dispatch({
      type: UPDATE_DEPARTMENT,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: UPDATE_DEPARTMENT,
      payload: null
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: error
    });
  }
};

export const deleteDepartment = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: true
    });
    const result = await axios().delete(`/departments/${id}`);
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: DELETE_DEPARTMENT,
      payload: result.status
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: null
    });
  } catch (error) {
    dispatch({
      type: DELETE_DEPARTMENT,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_DEPARTMENT,
      payload: false
    });
    dispatch({
      type: ERROR_DEPARTMENT,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
